import { IFoCaAnTruongRequest } from "../../../models/request/thuc-don/IFoCaAnTruongRequest";
import { IFoCaAnTruong, IFoCaAnTruongVm } from "../../../models/response/thuc-don/IFoCaAnTruong";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objCaAnTruongDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IFoCaAnTruongVm[],
    LOAD_ERROR: "",
    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as IFoCaAnTruongVm[],
    LOAD_COSO_ERROR: "",
    LOAD_CAAN_START: {} as IFoCaAnTruongRequest,
    LOAD_CAAN_SUCCESS: [] as IFoCaAnTruongVm[],
    LOAD_CAAN_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFoCaAnTruong | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFoCaAnTruong,
    SAVE_SUCESS: {} as IFoCaAnTruong,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eFoCaAnTruongActionTypeIds = generateActionTypeIds(objCaAnTruongDefine, "CA_AN_TRUONG")
export type IFoCaAnTruongActionTypes = IGenericActionType<typeof objCaAnTruongDefine, "CA_AN_TRUONG">
